module.exports = __webpack_public_path__ + "img/w3.ecc1c4f1.svg";